<template>
  <div class="barCss">
    <div class="progress">
      <div ref="bar" class="bar shadow hui"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    doIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {};
  },
  methods: {
    getup() {
      //   const bars = document.querySelectorAll(".bar");
      const randomWidth = this.doIndex * 20;

      const bars = this.$refs.bar;
      const progress = document.querySelectorAll(".progress");
      bars.style.width = `${randomWidth}%`;

      //   bars.forEach((bar, index) => {
      //     const randomWidth = this.doIndex * 20;

      //     bar.style.width = `${randomWidth}%`;

      //     // progress[index].addEventListener("mouseover", () => {
      //     //   const randomTiming = Math.floor(Math.random() * 2 + 2);
      //     //   console.log(randomTiming);
      //     //   bar.style.transitionDuration = `${randomTiming}s`;
      //     //   bar.style.width = "100%";
      //     // });
      //   });
    }
  },
  mounted() {
    this.getup();
  }
};
</script>

<style scoped>
/* @import url("https://fonts.googleapis.com/css?family=Bitter"); */

/* * {
    border: 1px solid red;
} */
:root {
  --font: "Bitter", serif;
  --title-size: 36px;
  --sub-size: 18px;
}

body {
  background: #e5e5e5;
}

.barCss {
  display: flex;
  align-items: center;
}
.title h1 {
  margin: 4px;
  font-family: var(--font);
  font-size: var(--title-size);
  color: #333;
}

.title p {
  margin: 4px;
  padding-bottom: 25px;
  font-family: var(--font);
  font-size: var(--sub-size);
  color: #888;
}

.container {
  text-align: center;
}

.progress {
  display: inline-block;
  width: 100%;
  height: 13px;
  border-radius: 20px;
  background: #f9f9f9;
  border: 1px #000 solid;
}

.bar {
  border-radius: 20px;
  width: 0%;
  height: 100%;
  transition: width;
  transition-duration: 1s;
  transition-timing-function: cubic-bezier(0.36, 0.55, 0.63, 0.48);
}

.mobile {
  display: none;
}

.shadow {
  /* 25 50 */
  box-shadow: 0px 45px 50px rgba(0, 0, 0, 0.25);
}

.hui {
  background-color: #ccc;
  background-image: url("../../../../assets/icon/pblCourse/DiagonalLine.png");
}

.stripes {
  background-color: #ffffff;
  background-image: url("data:image/svg+xml,%3Csvg width='25' height='1' viewBox='0 0 40 1' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 0h20v1H0z' fill='%23d09af3' fill-opacity='0.54' fill-rule='evenodd'/%3E%3C/svg%3E");
}
</style>



// WEBPACK FOOTER //
// src/components/pages/pblCourse/component/bars.vue